/**
 * The frame rate and the time a frame takes to draw, in the bottom-left corner: F toggles it (or
 * ?fps=1). A low rate with a short draw time means the GPU is the limit, a long draw time the CPU.
 */

import { drawText } from '../../ui/font8';

/** How quickly the averages follow a change (per frame). */
const SMOOTHING = 0.05;

export class FrameMeter {
  private last = -1;
  private intervalMs = 1000 / 60;
  private drawMs = 0;

  constructor(public shown: boolean) {}

  /** A frame was drawn at `now` (ms), its drawing having taken `drawMs`. */
  frame(now: number, drawMs: number): void {
    if (this.last >= 0) this.intervalMs += (Math.min(250, now - this.last) - this.intervalMs) * SMOOTHING;
    this.last = now;
    this.drawMs += (drawMs - this.drawMs) * SMOOTHING;
  }

  /** Draw the readout onto the HUD (640x360 base units), if shown. */
  paint(ctx: CanvasRenderingContext2D | null): void {
    if (!this.shown || !ctx) return;
    const fps = 1000 / this.intervalMs;
    const text = `${fps.toFixed(0)} FPS  ${this.drawMs.toFixed(1)} MS`;
    drawText(ctx, text, 5, 351, '#120e1c');
    drawText(ctx, text, 4, 350, fps < 50 ? '#ff3a6a' : '#9be36a');
  }
}
